import React, { useState } from 'react'
import './SubscribeForm.css'

const SubscribeForm = () => {
    const [formData, setFormData] = useState({
        EMAIL: '',
    });

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e: any) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault(); // prevent the default form behavior

        try {
            const response = await fetch('https://d427d68c.sibforms.com/serve/MUIFAFm-IrVl5PRcxStBFL6ifcgtG43uaN0ezlYBOFbiby_JOlb0QBM77oDTfImZ7ff380Ozpg6Sm1METyVUKjDHHSgfR5cvWvwTbp_AEgT48nYKSLXjrHQN3uecyhS-gGNgUGa-kejKXrbOpFAqhJGCuB8SGt1VLsNYBmVadOrN2hKzoAx_713mpRIlgyrQi5MWAHcb3pmajtpO', {
                method: 'POST',
                mode: 'no-cors',  // Important because Sendinblue won't return CORS headers
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData).toString(),
            });

            setSubmitted(true);
            setError('');

            // Reset form after 6 seconds
            setTimeout(() => {
                setSubmitted(false);
                setFormData({
                    EMAIL: ''
                });
            }, 6000); // 6 seconds delay
        } catch (err) {
            console.error('Error submitting the form:', err);
            setError('Something went wrong. Please try again.');
        }
    };

    return (
        <div className="subscribe-wrapper">
            {submitted ? (
                <div className="thank-you-message">
                    <h1>Thank you for subscribing!</h1>
                </div>
            ) : (
                <form id="sub-form" onSubmit={handleSubmit} className="my-sub-form">

                    <div className='blog-mini-div'>
                        <h1>The storm moves fast. We move faster. Get updates on the future of detection.</h1>
                    </div>

                    <div className="sub-form-items-and-text">
                        <div className="sub-form-items">
                            {/* Email */}
                            <div className="sub-form-block">
                                <input
                                    className="subs-input"
                                    type="email"
                                    name="EMAIL"
                                    placeholder="Email"
                                    value={formData.EMAIL}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            {/* Submit Button */}
                            <button
                                className="subs-submit-button"
                                type="submit"
                            >
                                Send
                            </button>
                        </div>

                        <p>Sign up for monthly updates on our progress, partnerships, and the evolution of
                            High-Risk-Lightning™ detection.</p>
                    </div>

                    {error && <p className="error-message">{error}</p>}
                </form>
            )}
        </div>
    );

}

export default SubscribeForm